import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import Hero from '../components/Hero.jsx';
import Description from '../components/Description.jsx';
import Benefits from '../components/Benefits.jsx';
import Studios from '../components/Studios.jsx';
import Models from '../components/Models.jsx';
import Testimonials from '../components/Testimonials.jsx';
import CTA from '../components/CTA.jsx';
import HomeNovedadesBubble from '../components/HomeNovedadesBubble.jsx';

function HomePage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [hash]);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Description />
        <Benefits />
        <Studios />
        <Models />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
      <HomeNovedadesBubble />
    </div>
  );
}

export default HomePage;
